import './style.scss'

export default function Wrapper({children}) {
    return <main>
        <h1>AI Tools</h1>
        {children}
    </main>
}
